import { capitalizeWords } from "../../../../utils/format-display-text.ts";
import type { ItApprovalEmployeeRow } from "../schemas/it-approval-employee.schema.ts";

function titleCaseWord(word: string): string {
  const trimmed = word.trim();
  if (trimmed === "") return "";
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

/** Title-cases one name segment; empty optional values return "" (form uses readOnlyFieldValue). */
export function formatItApprovalNamePart(value: string | null | undefined): string {
  if (value == null) return "";
  const trimmed = value.trim();
  if (trimmed === "") return "";
  return titleCaseWord(trimmed);
}

/** Formats joining date as dd-mm-yyyy from doj or joiningDate. */
export function formatItApprovalJoiningDate(
  row: Pick<ItApprovalEmployeeRow, "doj" | "joiningDate">,
): string {
  const raw = row.doj ?? row.joiningDate;
  if (raw == null || typeof raw !== "string") return "";
  const trimmed = raw.trim();
  if (trimmed === "") return "";

  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day}-${month}-${year}`;
  }

  const dmyMatch = /^(\d{2})-(\d{2})-(\d{4})$/.exec(trimmed);
  if (dmyMatch) return trimmed;

  return trimmed;
}

export function formatItApprovalGender(value: string | null | undefined): string {
  if (value == null) return "";
  const trimmed = value.trim();
  if (trimmed === "") return "";
  return capitalizeWords(trimmed);
}

export function formatItApprovalPhone(value: string | null | undefined): string {
  if (value == null) return "";
  return value.trim();
}
